import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { environment } from "../../environments/environment";
import { SupportService } from '../services/support.service';
import { AuthService } from '../services/auth/auth.service';
import { BrandDataService } from '../services/brand-data.service';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent implements OnInit {
    toggleSupport = false
    allowAccess = false;
    duration: string = '';
    processingGrant = false;
    processingSave = false;
    processingRevoke = false;
    loading = true
    adjustment = 0;
    isPyrocast = true;
    ignite = false;
    siteName = 'Pyrocast';
    activeConsentStatus = false;
    domainUrl= '';
    color = '';
    granted_at = '';
    expires_at = '';
    errorMessage = '';
    constructor(
        private dialogRef: MatDialogRef<SettingsComponent>,
        public supportService: SupportService,
        public authService: AuthService,
        private brandDataService: BrandDataService
    ) {
        // if (window.localStorage.getItem('adjustment')) {
        //     this.adjustment = Number(window.localStorage.getItem('adjustment'));
        // }
        // if (window.location.hostname == environment.skyDomain) {
        //     this.isPyrocast = false;
        //     this.siteName = 'SkyStreamEvents';
        //     this.ignite = false;
        // }
        // if (window.location.hostname == environment.igniteDomain) {
        //     this.isPyrocast = false;
        //     this.ignite = true;
        //     this.siteName = 'IGNITE LIVE';
        // }
        // else if (window.location.hostname == environment.tune2Domain || window.location.hostname == environment.tune2Domain2) {
        //     this.isPyrocast = false;
        //     this.siteName = 'Tune2';
        //     this.ignite = false;
        // }

        const brand = this.brandDataService.getBrandPayload();

        this.siteName = brand.siteName;
        this.isPyrocast = brand.isPyrocast;
        this.domainUrl = brand.domainUrl
        this.ignite = brand.ignite;
        this.color = brand.color;
    }

    // ngOnInit(): void {
    //     this.supportService.getGrantStatus().subscribe((result: any) => {
    //         this.activeConsentStatus = result.activeConsentStatus
    //         if (this.activeConsentStatus) {
    //             this.toggleSupport = true
    //             this.granted_at = result.consentDetails.granted_at
    //             this.expires_at = result.consentDetails.expires_at
    //         }
    //     })
    // }

    ngOnInit(): void {
        this.loading = true

        this.supportService.getGrantStatus().subscribe({
            next: (result: any) => {
                this.activeConsentStatus = result.activeConsentStatus
                if (this.activeConsentStatus) {
                    this.toggleSupport = true
                    this.granted_at = result.consentDetails.granted_at
                    this.expires_at = result.consentDetails.expires_at
                }
            },
            error: () => {
                this.loading = false
            },
            complete: () => {
                this.loading = false
            }
        })
    }

    grant() {
        this.errorMessage = ''
        if (this.processingGrant) return;
        if (!this.duration) {
            this.errorMessage = "Please select a duration"
            return
        }


        this.processingGrant = true;

        this.supportService.grantSupport(this.convertDurationStringToNumber()).subscribe({
            next: (result: any) => {
                if (result.success) {
                    this.activeConsentStatus = true;
                    this.expires_at = result.consentDetails.expires_at
                    this.granted_at = result.consentDetails.granted_at;
                }
            },
            error: (err) => {
                // optional: show error message
                console.error(err);
                this.processingGrant = false;
            },
            complete: () => {
                this.processingGrant = false;
            }
        });
    }


    revoke() {
        if (this.processingRevoke) return

        this.processingRevoke = true

        this.supportService.revokeSupport().subscribe({
            next: (result: any) => {
                if (result.success) {
                    this.activeConsentStatus = false
                }
            },
            error: (err) => {
                // optional: show error message
                console.error(err);
                this.processingRevoke = false;
            },
            complete: () => {
                this.processingRevoke = false;
            }
        })
    }

    save() {
        window.localStorage.setItem('adjustment', this.adjustment + '')
        this.dialogRef.close(false);
    }

    cancel() {
        this.dialogRef.close(false);
    }

    adjust(add: boolean) {
        this.adjustment += (add ? 1 : -1) * 0.1;
    }

    convertDurationStringToNumber() {
        console.log(this.duration)
        if (this.duration === 'ONE_DAY') return 1
        else if (this.duration === 'ONE_WEEK') return 7
        else if (this.duration === 'ONE_MONTH') return 30
        else if (this.duration === 'ONE_YEAR') return 365
        else if (this.duration === 'INDEFINITELY') return null

        return -1
    }
}